/**
 * @fileoverview POST handler for the "/free_trial/submit_pre_verification" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialSubmitPreVerificationCacheKeys } from "./constants";
import type { PostFreeTrialSubmitPreVerificationProps, FreeTrialSubmitPreVerificationResult } from "./types";

export const postFreeTrialSubmitPreVerification = reactQueryMutationAdapter(
  freeTrialSubmitPreVerificationCacheKeys,
  (props: PostFreeTrialSubmitPreVerificationProps): Promise<FreeTrialSubmitPreVerificationResult> => {
    return fetch("/free_trial/submit_pre_verification", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
